var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamioneta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Van-4",
    "data-name": "Van"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 32v-16a2.006 2.006 0 0 1 2-2h39.51a5.993 5.993 0 0 1 4.25 1.76l2.24 2.24h-43a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h31v16h-18a6 6 0 0 0 -12 0h-2a4 4 0 0 1 -4-4z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 44v-16h21.45a5.879 5.879 0 0 1 .55 2.49v1.51h-4a2.006 2.006 0 0 0 -2 2 2.015 2.015 0 0 0 2 2h4v6a2.006 2.006 0 0 1 -2 2h-4a6 6 0 0 0 -12 0z",
    fill: "#ffa733"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 44,
    fill: "#57565c",
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 44,
    fill: "#57565c",
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 18v10h-31a1 1 0 0 1 -1-1v-8a1 1 0 0 1 1-1z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 32v4h-4a2.015 2.015 0 0 1 -2-2 2.006 2.006 0 0 1 2-2z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.45 28h-21.45v-10h12l8.24 8.24a5.706 5.706 0 0 1 1.21 1.76z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 51a7 7 0 1 1 7-7 7.008 7.008 0 0 1 -7 7zm0-12a5 5 0 1 0 5 5 5.006 5.006 0 0 0 -5-5z",
    fill: "#3e3d42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 51a7 7 0 1 1 7-7 7.008 7.008 0 0 1 -7 7zm0-12a5 5 0 1 0 5 5 5.006 5.006 0 0 0 -5-5z",
    fill: "#3e3d42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 39h4v2h-4z",
    fill: "#ff6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 31h4v2h-4z",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 43h2v2h-2z",
    fill: "#3e3d42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 43h2v2h-2z",
    fill: "#3e3d42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 31h4v2h-4z",
    fill: "#ff6243"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamioneta);
export default __webpack_public_path__ + "static/media/camioneta.27354042c0d68822021b21430a9209c8.svg";
export { ForwardRef as ReactComponent };